// extracted by mini-css-extract-plugin
module.exports = {"listItemInfoTitleContainer":"GiftTitle_listItemInfoTitleContainer__ydf6M"};